<template>
  <div class="tool-tip" ref="tool-tip" :style="{'max-width':maxWidth}">
    <div class="tool-tip-content" ref="tool-tip-content" @mouseover="showTip">
      <div class="tool-tip-content--span" ref="tool-tip-content--span">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import tippy, {followCursor} from 'tippy.js';
export default {
  props: {
    title: {
      type: [Object, String, Number,Array, Boolean]
    },
    width: {
      type: [Number, String],
      default: ''
    },
    maxWidth: {
      type: [Number, String]
    },
    offset: {
      type: Number,
      default: 0
    },
    show: {
      type: Boolean,
      default: false
    },
    isOver: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tippyInstance: ''
    }
  },
  watch: {
  },
  mounted() {
  },
  updated() {
  },
  methods: {
    showTip(e) {
      this.clear()
      if (this.show) {
        this.showBox(e)
        return
      }
      let content = this.$refs['tool-tip-content--span']
      let box = this.$refs['tool-tip']
      let ele = this.$refs['tool-tip-content']
      if (!box) { return }
      if (!this.maxWidth) {
        let width = content.offsetWidth + 10
        if (content.offsetWidth + 10 - ele.offsetWidth >= this.offset) {
          width = width - this.offset
        }
        box.style['max-width'] = width + 'px'
      }
      if (content.offsetWidth > box.offsetWidth) {
        this.showBox(e)
      }
    },
    showBox(e) {
      this.tippyInstance = tippy(e.target, {
        followCursor: 'horizontal',
        plugins: [followCursor],
        placement: 'top',
        theme: 'toolTip',
        allowHTML: true,
        arrow: true,
        maxWidth: 300,
      });
      let tooltipContent = `<div style="font-size:12px;">${this.title}</div>`
      this.tippyInstance.setContent(tooltipContent)
      this.$emit('update:isOver', true)
    },
    clear() {
      if (this.tippyInstance) {
        this.tippyInstance.unmount()
        this.tippyInstance.destroy()
        this.tippyInstance = ''
      }
      this.$emit('update:isOver', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.tool-tip {
  // width: 100%;
  position: relative;
  z-index: 99;
  .my-arrow-tip {
    height: 27px;
    background: #3c4b62;
    box-shadow: 0px 2px 4px 0px rgba(117, 116, 142, 0.2);
    border-radius: 2px;
    color: #fff;
    position: fixed;
    // top: -100%;
    display: none;
    line-height: 27px;
    text-align: center;
    padding: 0 10px;
    transition: all 0.1s;
    font-size: 12px;
    transform: translate(0);
    z-index: 100;
  }
  .arrow-tool-tip {
    width: 0;
    height: 0;
    border: 4px solid transparent;
    border-top-color: rgba(13, 31, 60, 0.8);
  }
  .tool-tip-content {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    position: relative;
    z-index: 2;
  }
  .tool-tip-content--span {
    width: 100%;
    display: inline;
    position: relative;
    z-index: -1;
    line-height: initial;
  }
}
</style>
